module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAtCAYAAADYxvnjAAAAAXNSR0IArs4c6QAAAVFJREFUWEftmb9qAkEQxr8R/7SKWOQBTkzAPq+RxuLAPIMpTG0rNvoMwhUWNj5EXiAE4r1BithKNE4QDJyLcpPMsSc4Vx3cDvftb77ZWXbpbsblzQYjEB4BVJF4CFgxY1oqof/Woa/kN9/vFEQ8BPCc8uNJHFLPt7gjaEHEK5fkCUGfcUj1vIWyREAcEknG/WvMgAvNFtr8jUYyvkD4eF/iFQPa7VOfq9DbKd9si5iDcX9mki+8Qyd3oUHEcwAPKZlYXILQNYBKitD1JQgVWc+ESqtfWszXQ/S3BROhy0Dtry3YG1FhCx7HIT2dsoNPoaoW7FOoaHk514JNqOszKREj6pLTEtHGqxd8S72TUiOatceNqBFN2+hq10FtvHnUPGoePRCwYsq6GIyoEXUISDfe1pmyto4RvWqi2kMuL/Hqm7sMjh0lN4dj0t6Fag9ypfE/f1jswbVxwckAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-5.png
// module id = BWQN
// module chunks = 1